@if (loadingFailed) {
  <div class="loading-failed">
    <span class="fa-solid fa-exclamation-triangle"></span>
    <span>Failed to load instance.</span>
 </div>
}
@else if(!loaded) {
  <kendo-loader></kendo-loader>
}
@else {
  <div class="reports-tab">   
    <kendo-tabstrip>
      <kendo-tabstrip-tab title="My Reports" [selected]="true">
        <ng-template kendoTabContent>
          <div class="finder" style="margin-top:15px;">
            <div class="header">
                <nav class="breadcrumb">
                    <ng-container *ngFor="let folder of breadcrumb; let last = last">
                        <span 
                            (click)="NavigateToBreadcrumb(folder)" 
                            [class.active]="last">
                        <span *ngIf="!folder && breadcrumb.length > 1" class="fas fa-home folder-home-button"></span>{{ folder ? folder.Name : 'Reports' }}
                        </span>
                        <span *ngIf="!last">
                            <span class="fas fa-chevron-right breadcrumb-separator"></span>
                        </span>
                    </ng-container>
                </nav>
                <button kendoButton class="create-folder-btn" (click)="OpenCreateFolderDialog()">+ Create Folder</button>
            </div>
            <div class="content">
              <ul class="items">
                <!-- Loop for Folders -->
                <li *ngFor="let folder of folders" (click)="NavigateToFolder(folder)">
                    <div class="folder-item">
                      <span class="fas fa-folder"></span>
                      <span>{{ folder.Name }}</span>
                      <!-- Ellipsis Overlay -->
                      <button class="ellipsis-btn" (click)="OpenPopupMenu(folder, $event)">
                        <span class="fas fa-ellipsis-v"></span>
                    </button>
                  </div>
                </li>
                <!-- Loop for Reports -->
                <li *ngFor="let report of reports">
                    <div class="report-item" (click)="OpenReport(report)">
                      <span class="fas fa-file-alt"></span>
                      <span>{{ report.Name }}</span>
                      <!-- Ellipsis Overlay -->
                      <button class="ellipsis-btn" (click)="OpenPopupMenu(report, $event)">
                          <span class="fas fa-ellipsis-v"></span>
                      </button>
                    </div>
                </li>
              </ul>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <kendo-tabstrip-tab title="Shared with me">
        <ng-template kendoTabContent>
          <kendo-grid
            [data]="sharedReports"
            [height]="400"
            [pageSize]="10"
            [selectable]="{ mode: 'single' }"
            [pageable]="true"
            [sortable]="true"
            (selectionChange)="OnSharedReportSelected($event)"
          >
            <kendo-grid-column field="Name" title="Name" [width]="200"></kendo-grid-column>
            <kendo-grid-column field="User" title="Owner" [width]="200"></kendo-grid-column>
            <kendo-grid-column field="Description" title="Description"></kendo-grid-column>
          </kendo-grid>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip> 
  </div>

  <div 
        class="popup-menu" 
        [ngStyle]="contextMenuStyle" 
        #popupMenu
        *ngIf="isPopupOpen"
    >
      <ul>
        <li (click)="RenameItem()">Rename</li>
        <li (click)="ConfirmDelete()">Delete</li>
        <li (click)="OpenMoveDialog()">Move</li>
      </ul>  
  </div>

  <!-- Kendo Dialog for create folder -->
  <kendo-dialog *ngIf="isCreateFolderDialogOpen" 
                (close)="CloseCreateFolderDialog()"
                [width]="500"
  >
    <kendo-dialog-titlebar>
      Create New Folder
    </kendo-dialog-titlebar>
    <div class="dialog-content">
      <label for="folderName">Folder Name:</label>
      <input
        id="folderName"
        type="text"
        [(ngModel)]="newFolderName"
        placeholder="Enter folder name"
      />
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="CreateFolder()">OK</button>
      <button kendoButton (click)="CloseCreateFolderDialog()">Cancel</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Kendo Confirm Dialog for Delete -->
  <kendo-dialog *ngIf="isDeleteConfirmOpen" (close)="CloseDeleteConfirm()">
    <kendo-dialog-titlebar>Confirm Delete</kendo-dialog-titlebar>
    <p>Are you sure you want to delete <strong>{{ selectedReport ? selectedReport.Name : selectedFolder?.Name }}</strong>?</p>
    <kendo-dialog-actions>
      <button kendoButton (click)="DeleteItem()">Yes</button>
      <button kendoButton (click)="CloseDeleteConfirm()">No</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Kendo Dialog for Rename -->
  <kendo-dialog *ngIf="isRenameDialogOpen" (close)="CloseRenameDialog()">
    <kendo-dialog-titlebar>Rename</kendo-dialog-titlebar>
    <div class="dialog-content">
      <label for="renameInput">New Name:</label>
      <input id="renameInput" [(ngModel)]="renameName" placeholder="Enter new name" />
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="RenameConfirm()">Save</button>
      <button kendoButton (click)="CloseRenameDialog()">Cancel</button>
    </kendo-dialog-actions>
  </kendo-dialog>


  <!-- Kendo Dialog for Move Report -->
  <kendo-dialog *ngIf="isMoveDialogOpen" (close)="CloseMoveDialog()" [width]="500">
    <kendo-dialog-titlebar>
      Move {{ selectedReport ? 'Report' : 'Folder' }} {{ selectedReport ? selectedReport.Name : selectedFolder?.Name }}
    </kendo-dialog-titlebar>
    <div class="dialog-content">
      <p>Select the target folder:</p>
      <kendo-treeview
        [nodes]="folderTreeData"
        textField="text"
        [kendoTreeViewExpandable]="true"
        [kendoTreeViewSelectable]="true"
        (nodeClick)="OnTreeNodeClick($event)"
        [children]="children"
        [hasChildren]="hasChildren"
        [isExpanded]="isExpanded"
        [isDisabled]="isDisabled"
      >
        <ng-template kendoTreeViewNodeTemplate let-dataItem>
          <span [ngClass]="iconClass(dataItem)"></span>
          {{ dataItem.text }}
        </ng-template>
      </kendo-treeview>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="ConfirmMove()" [disabled]="!selectedMoveFolder">Move</button>
      <button kendoButton (click)="CloseMoveDialog()">Cancel</button>
    </kendo-dialog-actions>
  </kendo-dialog> 
}